import React, { ChangeEvent } from 'react';
import { Switch } from '../../../../../../components/switch';
import { useSwitch } from '../../../../hooks/switch';
import { ChannelType } from '../../../../types';

type SwitchControlProps = {
  channel: ChannelType;
};

export const SwitchControl: React.FC<SwitchControlProps> = ({ channel }) => {
  const { handleControlOn: onSwitch, isOn: isOnSwitch } = useSwitch({
    channelId: channel.id,
    deviceId: channel.deviceId,
  });

  const handleControl = (e: ChangeEvent<HTMLInputElement>) => onSwitch(e.target.checked);

  return <Switch checked={isOnSwitch} onChange={handleControl} />;
};
